export default __webpack_public_path__ + "static/Cashflow 101+202-9-651ab089a6c2ad789332efcbc8f68892.jpg";